export default [
  {
    path: 'project',
    name: 'PtoProjectDetailedProject',
    component: () => import('@/views/Pto/Project/project/PtoProjectDetailedProject.vue'),
    redirect: {
      name: 'PtoProjectUpdate'
    },
    children: [
      {
        path: 'update',
        name: 'PtoProjectUpdate',
        component: () => import('@/views/Pto/Project/project/PtoProjectUpdate.vue')
      },
      {
        path: 'change',
        name: 'PtoProjectChange',
        component: () => import('@/views/Pto/Project/project/PtoProjectChange.vue')
      },
      {
        path: 'document',
        name: 'PtoProjectDocument',
        component: () => import('@/views/Pto/Project/project/PtoProjectDocument.vue')
      },
      {
        path: 'statement',
        name: 'PtoProjectStatement',
        component: () => import('@/views/Pto/Project/project/PtoProjectStatement.vue')
      },

      // Create
      {
        path: 'change/create',
        name: 'PtoProjectChangeCreate',
        component: () => import('@/views/Pto/Project/project/PtoProjectChangeCreate.vue')
      },
      {
        path: 'statement/create',
        name: 'PtoProjectStatementCreate',
        component: () => import('@/views/Pto/Project/project/PtoProjectStatementCreate.vue')
      },

      // Detailed
      {
        path: 'change/:id',
        name: 'PtoProjectChangeUpdate',
        component: () => import('@/views/Pto/Project/project/PtoProjectChangeUpdate.vue')
      },
      {
        path: 'document/:id',
        name: 'PtoProjectDocumentUpdate',
        component: () => import('@/views/Pto/Project/project/PtoProjectDocumentUpdate.vue')
      },
      {
        path: 'statement/:id',
        name: 'PtoProjectStatementUpdate',
        component: () => import('@/views/Pto/Project/project/PtoProjectStatementUpdate.vue')
      }
    ]
  }
]
